import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { AiOutlinePlus, AiOutlineCheckCircle, AiFillCalendar } from 'react-icons/ai'
import { useTimerGuard } from '../../../../hooks/useTimerGuard'
import BlockTimerModal from '../../../../components/Timer/BlockTimerModal'
import './styles.css'

interface PlanningEmptyStateProps {
  isDarkMode?: boolean
}

const PlanningEmptyState: React.FC<PlanningEmptyStateProps> = ({ isDarkMode = false }) => {
  const history = useHistory()
  const { checkAndBlock } = useTimerGuard()
  const [isBlockModalOpen, setIsBlockModalOpen] = useState(false)
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null)

  const handleCreatePlan = () => {
    const action = () => {
      history.push('/planejamento/novo')
    }

    if (
      checkAndBlock(() => {
        setPendingAction(() => action)
        setIsBlockModalOpen(true)
      })
    ) {
      return
    }

    action()
  }

  const handleCloseBlockModal = () => {
    setIsBlockModalOpen(false)
    setPendingAction(null)
  }

  const handleFinishSession = () => {
    setIsBlockModalOpen(false)
    if (pendingAction) {
      pendingAction()
      setPendingAction(null)
    }
  }

  const features = [
    'Crie planos de estudo personalizados',
    'Acompanhe seu progresso ao longo do tempo',
    'Distribua suas horas de estudo com inteligência',
    'Utilize o cronômetro e mantenha o ritmo',
    'Gerencie múltiplos planos sem bagunça',
    'Visualize sua sequência e mantenha a constância',
  ]

  return (
    <>
      <div className={`planning-empty-state ${isDarkMode ? 'dark' : 'light'}`}>
        <div className="planning-empty-state-content">
          <div className="planning-empty-state-icon">
            <AiFillCalendar size={48} />
          </div>

          <h1 className="planning-empty-state-main-title">Planejador de Estudos</h1>

          <p className="planning-empty-state-subtitle">
            Organize e acompanhe seus estudos de forma estruturada e eficiente
          </p>

          <div className="planning-empty-state-features">
            <h3 className="planning-empty-state-features-title">O que você pode fazer:</h3>
            <ul className="planning-empty-state-features-list">
              {features.map((feature, index) => (
                <li key={index} className="planning-empty-state-feature-item">
                  <AiOutlineCheckCircle className="planning-empty-state-feature-icon" size={20} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="planning-empty-state-cta">
            <p className="planning-empty-state-cta-text">
              Crie seu primeiro plano personalizado em apenas 4 passos rápidos
            </p>
            <button
              className="planning-empty-state-button"
              onClick={handleCreatePlan}
              type="button"
              data-tour="empty-state-create-button"
            >
              <AiOutlinePlus size={20} />
              <span>Criar meu primeiro plano</span>
            </button>
          </div>
        </div>
      </div>
      <BlockTimerModal
        isOpen={isBlockModalOpen}
        onClose={handleCloseBlockModal}
        onFinish={handleFinishSession}
      />
    </>
  )
}

export default PlanningEmptyState
